function coalesceProjectFlag(response, ...keys) {
  const project = response?.Project ?? response?.project
  for (const key of keys) {
    const v = response?.[key] ?? project?.[key]
    if (v !== undefined && v !== null) return v
  }
  return undefined
}

/** Maps fractional-data API; forwards project-level flags used by payment flow (same semantics as add-sales `project.paymentProof`). */
export default function fractionalDataTransformer(response, _meta, arg) {
  const project = response?.Project ?? response?.project
  return {
    availableBlockCount: response?.availableFractions,
    pricePerBlock: response?.pricePerFraction,
    soldFractions: response?.soldFractions,
    processingFee: response?.processingFee ?? project?.processingFee,
    partnerFee: response?.partnerFee ?? project?.partnerFee,
    advanceTax: response?.advanceTax ?? project?.advanceTax,
    paymentProof: coalesceProjectFlag(response, "paymentProof", "payment_proof"),
    isRAFlowEnabled: coalesceProjectFlag(response, "isRAFlowEnabled", "is_ra_flow_enabled"),
  }
}
